module.exports = __webpack_public_path__ + "img/logo.cf7574b9.png";